class AcceleratedCheckoutGuard {
  constructor(container) {
    this.container = container;
    this.guard = container.querySelector('.accelerated-checkout-guard');

    const sectionId = container.closest('[data-section-id]')?.dataset.sectionId;
    this.variantPicker = sectionId
      ? document.querySelector(`variant-picker[data-section-id="${sectionId}"]`)
      : document.querySelector('variant-picker');

    if (!this.guard || !this.variantPicker) return;

    this.guard.addEventListener('click', this.handleGuardClick.bind(this));
    this.variantPicker.addEventListener('change', () => this.refresh());
    this.refresh();
  }

  allOptionsSelected() {
    const groups = this.variantPicker.querySelectorAll('.variant-option');
    for (const group of groups) {
      const radios = group.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        if (![...radios].some((r) => r.checked)) return false;
        continue;
      }
      const select = group.querySelector('select');
      if (select && !select.value) return false;
    }
    return true;
  }

  refresh() {
    this.guard.dataset.active = this.allOptionsSelected() ? 'false' : 'true';
  }

  handleGuardClick(event) {
  event.preventDefault();
  event.stopPropagation();

  this.variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  this.variantPicker.classList.add('variant-picker--error');

  window.SizeErrorToast?.show('Please select some product options before adding this product to cart.');

  setTimeout(() => this.variantPicker.classList.remove('variant-picker--error'), 1200);
}
}

document.querySelectorAll('.accelerated-checkout-block').forEach((el) => new AcceleratedCheckoutGuard(el));